import React from "react";
import { Link } from "react-router-dom";
import Container from "../../utils/Container";
import logo from "../../../medias/logo/logo-dark.svg";
import logoSmall from "../../../medias/logo/logo-dark-small.svg";
import Paragraph from "../../elements/p/Paragraph";
import useResizeWindow from "../../../hooks/ResizeWindow";

const Footer = ({ classe }) => {
  //custom hook
  const [size] = useResizeWindow();

  return (
    <footer className={`${classe} mb-10`}>
      <Container classe="md:flex items-center justify-between">
        <img
          src={size > 768 ? logo : logoSmall}
          alt="Logo de nti technologie"
          className="inline-block w-14 cursor-pointer md:w-28"
        />
        <ul className="mt-4 flex space-x-5 md:mt-0 md:space-x-10">
          <Link to="/">
            <Paragraph>Accueil</Paragraph>
          </Link>

          <Link to="/produits">
            <Paragraph>Articles</Paragraph>
          </Link>
          <Link to="/localisation">
            <Paragraph>Localisation</Paragraph>
          </Link>
          <a target="_blank" rel="noreferrer" href="https://wa.me/237674651112">
            <Paragraph>Contact</Paragraph>
          </a>
        </ul>
        <p className="mt-4 font-nunito text-xs italic text-secondary/70 md:mt-0 md:text-sm">
          développé par{" "}
          <a
            href="https://www.linkedin.com/in/ngimdock-zemfack/"
            target="_blank"
            rel="noreferrer"
            className="animate underline hover:text-primary"
          >
            ngimdock zemfack
          </a>{" "}
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
